import React from 'react';
import '../TeleCalling.css';
import { Box, Typography } from '@mui/material';
import { StyledLeadContainer } from '../../Styled';
import TextFiledWithLabel from '../../TextFieldWithLabel';
import { useIsMobile } from '../../../Utility/hooks/useIsMobile';
import history from '../../../Utility/history';
import { privateRoutesPath } from '../../../Routes';
import { handleValidateCodevalue } from '../../../Utility/constant';


const CustomerCard = ({ customer, internationalise, minimize }) => {
    const isMobile = useIsMobile();

    return (
        <StyledLeadContainer>
            {/* Customer ID — navigable link */}
            <Box>
                {isMobile ? (
                    <>
                <Typography variant="caption" color="text.secondary" className="tc-section-header">
                    {handleValidateCodevalue(internationalise, 'CUST_EDIT_CUSTOMER_ID') || 'Customer ID'}
                </Typography>
                    <span
                        // onClick={() => {
                        //     history.push(`${privateRoutesPath.EDIT_CUSTOMER}/${customer.id}`);
                        //     minimize && minimize();
                        // }}
                        className="tc-entity-link"
                    >
                        {customer.id}
                    </span>
                    </>
                ) : (
                    <TextFiledWithLabel
                        onClick={() => {
                            history.push(`${privateRoutesPath.EDIT_CUSTOMER}/${customer.id}`);
                            minimize && minimize();
                        }}
                        value={customer.id}  
                        label = {handleValidateCodevalue(internationalise, 'CUST_EDIT_CUSTOMER_ID') || 'Customer ID'}
    
                        className = "readonly"
                         sx={{
                        "& .MuiInputBase-input": {
                          color: "var(--secondary-color) !important",
                          WebkitTextFillColor: "var(--primary-color)",
                          cursor: "pointer",
                          textDecoration: "none",
                        },
                        "& .MuiInputBase-input:hover": {
                          textDecoration: "underline",
                        },
                      }}
                    />
                )}
            </Box>

            {/* Latest product purchased */}
            <TextFiledWithLabel
                name="latestProduct"
                disabled
                value={customer.latestProductName}
                label={handleValidateCodevalue(internationalise, 'TC_LATEST_PRODUCT')}
            />

            {/* Date of last purchase */}
            <TextFiledWithLabel
                name="lastPurchaseDate"
                disabled
                value={
                    customer.lastPurchaseDate
                        ? new Date(customer.lastPurchaseDate).toLocaleDateString()
                        : ('')
                }
                label={handleValidateCodevalue(internationalise, 'TC_LAST_PURCHASE_DATE')}
            />

            {/* Total value (only when present) */}
            <TextFiledWithLabel
                name="totalValue"
                disabled
                value={ customer.totalValue != null
                    ? customer.totalValue.toFixed(2)
                : ""}
                label={handleValidateCodevalue(internationalise, 'CUSTOMER_TOTAL_VALUE')}
            />
        </StyledLeadContainer>
    );
};

export default CustomerCard;
